import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ValuePropBanner = (props) => {
    const { show } = props;

    if (!show) return null;

    const { copy } = props;

    return (
        <div className={cn('value-prop-banner')}>
            <p>
                {copy}
            </p>
        </div>
    );
};

ValuePropBanner.propTypes = {
    show: PropTypes.bool.isRequired,
    copy: PropTypes.string.isRequired
};

export default ValuePropBanner;
